const state = () => {
  try{
    let pet_page = JSON.parse(window.localStorage.getItem('pet_page'));
    let current_location = JSON.parse(window.localStorage.getItem('current_location'));
    let selected_location = JSON.parse(window.localStorage.getItem('selected_location'));
    let pet_gallery = JSON.parse(window.localStorage.getItem('pet_gallery'));
    let active_flyer = JSON.parse(window.localStorage.getItem('active_flyer'));
    // MINI_ALERTS
    let new_connection = JSON.parse(window.localStorage.getItem('new_connection'));
    let max_file_upload = JSON.parse(window.localStorage.getItem('max_file_upload'));
    let max_file_size = JSON.parse(window.localStorage.getItem('max_file_size'));

    return {
        //Main
      version_number: "v2.3.1",
      auth: false,
      api_key: '0bba2f2e5d9-f456a9c6-719d529cd-864e-6cc0-3eaae3bc753a',
      current_location: current_location || {latitude:null, longitude:null},
      token: localStorage.getItem('usertoken') || '',
      current_gallery: pet_gallery || [],
      last_visited: localStorage.getItem('last_visited') || null,
      userID: localStorage.getItem('uid') || '',
      new_tag: localStorage.getItem('tag_id') || '',
      onboarding_point: localStorage.getItem('onboarding_point') || '',
      theme: localStorage.getItem('theme') || 'light',
      sideMenu: 'core_menu',
      ownerID: localStorage.getItem('owner_id') || '',
      selected_location: selected_location || [],
      pet_data: pet_page || { tag_links: [''], bday: '01/01/2000' },
      processing: false,
      feedback: null,
      feedtype: '',
      active_flyer: active_flyer || { description: '', missing_date: '00/00/0000', showPhone: false, showEmail: true, offerReward:false, petID: ''},
      // offlineMode: localStorage.getItem('offlineMode') || false,
      // remote: localStorage.getItem('remote_settings') || {},
      //alerts
      new_connection: new_connection || {},
      max_file_upload: max_file_upload || {},
      max_file_size: max_file_size || {},
    }

  }catch(e){
    //check if error is JSON parse error
    if(e.name === 'SyntaxError' && e.message.includes('JSON')){
      window.localStorage.clear();
      location.reload();
    }
  }
}
// let remote_settings = JSON.parse(window.localStorage.getItem('remote_settings'));

export default state();
